import React, { useState } from 'react';
import { toast } from 'react-toastify';
import _ from 'underscore';

import FormModal from 'components/Modals/formModal';
import { ModalInput, ModalJsonInput } from './styles';

export default function SheetDataModal({ graphicsImage, closeModal, onConfirm }) {
  const [image, setImage] = useState({
    ...graphicsImage,
    jsonInput: graphicsImage.jsonData ? JSON.stringify(graphicsImage.jsonData, null, 2) : '',
  });

  const handleGenerateAnimation = (jsonData = '') => {
    let sheetData;
    try {
      jsonData = fixKeyNames(jsonData);
      sheetData = getJsonSheetAsObject(jsonData);
    } catch (error) {
      toast.error("Can't process invalid JSON\nNeed frames defined to generate animation");
      return;
    }
    if (!sheetData || !sheetData.frames || _.keys(sheetData.frames).length <= 0) {
      toast.error('Need frames defined to generate animation');
      return;
    }
    var sortedFrameNames = _.sortBy(_.keys(sheetData.frames), function (frameName) {
      var picIndexArray = frameName.match(/\d+/g);
      return picIndexArray && picIndexArray[0] ? parseInt(picIndexArray[picIndexArray.length - 1]) : -1;
    });

    if (!sheetData.animations) sheetData.animations = {};
    sheetData.animations['default'] = sortedFrameNames;

    let updatedImage = { ...image };
    if (!updatedImage.jsonData) updatedImage.jsonData = {};
    updatedImage.jsonData = sheetData;
    updatedImage.jsonInput = JSON.stringify(sheetData, null, 2);
    setImage(updatedImage);
  };

  const handleOnConfirm = () => {
    let sheetData;
    try {
      sheetData = getJsonSheetAsObject(fixKeyNames(image.jsonInput));
    } catch (error) {
      toast.error('invalid JSON');
      return;
    }

    onConfirm(image.description, sheetData);
    closeModal();
  };

  const fixKeyNames = (jsonData) => {
    var tmpObj = getJsonSheetAsObject(jsonData);
    if (tmpObj.frames) {
      _.keys(tmpObj.frames).forEach(function (oldKey) {
        if (oldKey.includes('.')) {
          var newKey = oldKey.replace(/\./g, '_');
          tmpObj.frames[newKey] = tmpObj.frames[oldKey];
          delete tmpObj.frames[oldKey];
        }
      });
    }
    return JSON.stringify(tmpObj, null, 2);
  };

  // Convert json sheet string to object
  const getJsonSheetAsObject = (jsonData) => {
    if (typeof jsonData === 'string') {
      // regex to replace non-escaped single quotes (for easy copy-paste)
      // Use only standard regex operations with good browser support
      var fixedString = jsonData.replace(/^'/, '"');
      while (/[^\\]'/.test(fixedString)) {
        fixedString = fixedString.replace(/[^\\]'/g, function (str) {
          return str[0] + '"';
        });
      }
      return JSON.parse(fixedString);
    }
    return JSON.parse(JSON.stringify(jsonData, null, 2));
  };

  return (
    <FormModal
      title="Configure image JSON data"
      confirmButtonText="Save"
      onCancel={closeModal}
      onConfirm={handleOnConfirm}
      additionalActionButton={[{ text: 'Generate Animation', onClick: () => handleGenerateAnimation(image.jsonInput) }]}
      //   loading={??}
    >
      Image: {graphicsImage.name}
      <ModalInput
        value={image.description || ''}
        onChange={(e) => setImage({ ...image, description: e.target.value })}
        placeholder="Optional description"
      ></ModalInput>
      <ModalJsonInput
        value={image.jsonInput}
        onChange={(e) => setImage({ ...image, jsonInput: e.target.value })}
        placeholder="JSON recommended to be auto generated by a tool such as spritesheet.js https://github.com/krzysztof-o/spritesheet.js"
      ></ModalJsonInput>
    </FormModal>
  );
}
